import type { BaseKeyFunction } from "../../../lib";

export const keyBackgroundSounds: BaseKeyFunction = () => ["backgroundSounds"];
